import script from "./ApprovalTable.vue?vue&type=script&setup=true&lang=js"
export * from "./ApprovalTable.vue?vue&type=script&setup=true&lang=js"

import "./ApprovalTable.vue?vue&type=style&index=0&id=808dc45e&scoped=true&lang=css"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-808dc45e"]])

export default __exports__